import { render } from "./PointComponent.vue?vue&type=template&id=e1309f2c&scoped=true"
import script from "./PointComponent.vue?vue&type=script&lang=js"
export * from "./PointComponent.vue?vue&type=script&lang=js"

import "./PointComponent.vue?vue&type=style&index=0&id=e1309f2c&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1309f2c"]])

export default __exports__